"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

// 메인 진입 페이지의 '플레이어' 카드 아래 — 플랫폼별 설치 안내.
// 안드로이드/데스크톱: 플레이 스토어(구글 TV·태블릿, 2026-09-07 심사 통과)를 앞세우고, APK 직접 설치는 보조.
// iOS: 웹 플레이어 안내(APK 불가). APK 링크는 상대경로 → 서빙 주소로 자동 연결.
type Platform = "android" | "ios" | "other";
// ⚠️ APK 를 새로 올리면 셋 다 같이 고칠 것 — 쿼리는 캐시버스터라 안 바꾸면 옛 APK 가 그대로 받아진다.
const APK_VERSION = "1.0.11";
const APK_DATE = "2026-09-14";
const PLAYER_APK_URL = `/download/player.apk?v=${APK_VERSION}`;
// 플레이 스토어 등록본(패키지 net.aitkd.player). 스토어판은 부팅 자동실행·오버레이를 쓰지 않는다(설치 경로로 분기).
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=net.aitkd.player";

function PlayIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4 3.5v17a1 1 0 0 0 1.5.87l14-8.5a1 1 0 0 0 0-1.74l-14-8.5A1 1 0 0 0 4 3.5Z" />
    </svg>
  );
}

export function PlayerInstall() {
  const [platform, setPlatform] = useState<Platform>("other");
  const t = useTranslations("playerInstall");

  useEffect(() => {
    const ua = navigator.userAgent || "";
    const isIOS =
      /iPhone|iPad|iPod/i.test(ua) ||
      // iPadOS 는 데스크톱 UA(Macintosh)로 위장 — 터치 포인트로 구분
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    if (/Android/i.test(ua)) setPlatform("android");
    else if (isIOS) setPlatform("ios");
    else setPlatform("other");
  }, []);

  if (platform === "ios") {
    return (
      <p className="max-w-md text-center text-[13px] leading-relaxed text-[#6B7280]">
        {t.rich("iosGuide", { b: (chunks) => <b className="text-[#111827]">{chunks}</b> })}
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center gap-2">
    {/* 카드와 같은 글라스 언어 유지 + 레드 accent 로 CTA 존재감↑ (플레이어=레드). 레드틴트 글라스 pill. */}
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2.5 rounded-full border border-[rgba(239,68,68,.3)] bg-[rgba(239,68,68,.08)] px-6 py-3 text-[13.5px] font-bold text-[#DC2626] shadow-[inset_0_1px_0_rgba(255,255,255,.55),0_8px_22px_rgba(239,68,68,.14)] backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:border-[rgba(239,68,68,.45)] hover:bg-[rgba(239,68,68,.13)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,.55),0_12px_30px_rgba(239,68,68,.24)]"
    >
      <span className="text-[#EF4444]">
        <PlayIcon />
      </span>
      {t("storeBtn")}
    </a>
    <p className="max-w-xs text-center text-[11.5px] leading-relaxed text-[#9CA3AF]">
      {t("storeLine")}
      <br />
      {t.rich("apkLine", {
        a: (chunks) => (
          <a href={PLAYER_APK_URL} download className="underline decoration-[#D1D5DB] underline-offset-2 hover:text-[#6B7280]">
            {chunks}
          </a>
        ),
        version: APK_VERSION,
        date: APK_DATE,
      })}
    </p>
    </div>
  );
}
